import React from 'react';

const Billing = () => {
  const mockPayments = [
    { id: '1', gym: 'Muscle Factory', plan: 'pro', amount: 4999.00, status: 'Paid', date: '2026-05-15' },
    { id: '2', gym: 'Iron House', plan: 'starter', amount: 1999.00, status: 'Trial Active', date: '2026-05-20' }
  ];

  return (
    <div className="space-y-6 animate-fadeIn">
      <div>
        <h1 className="text-3xl font-bold text-white tracking-tight">Billing & Subscriptions</h1>
        <p className="text-gray-400 text-sm mt-1">Monitor billing ledgers, UPI references, and next renewals.</p>
      </div>

      <div className="bg-[#0F172A] border border-[#1E293B] rounded-xl shadow-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm text-gray-300">
            <thead className="text-xs text-gray-400 uppercase bg-[#0B0F19] border-b border-[#1E293B]">
              <tr>
                <th className="px-6 py-4">Gym Workspace</th>
                <th className="px-6 py-4">Subscribed Plan</th>
                <th className="px-6 py-4 text-center">Amount Due (₹)</th>
                <th className="px-6 py-4">Status</th>
                <th className="px-6 py-4">Billing Date</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#1E293B]">
              {mockPayments.map(p => (
                <tr key={p.id} className="hover:bg-[#1E293B]/20">
                  <td className="px-6 py-4 font-semibold text-white">{p.gym}</td>
                  <td className="px-6 py-4">
                    <span className="text-xs px-2 py-0.5 rounded font-mono uppercase bg-[#1E293B] text-gray-300 border border-gray-700">{p.plan}</span>
                  </td>
                  <td className="px-6 py-4 text-center font-mono">₹{p.amount.toFixed(2)}</td>
                  <td className="px-6 py-4">
                    <span className={`px-2 py-0.5 rounded text-xs font-semibold ${
                      p.status === 'Paid' ? 'bg-[#6CD800]/10 text-[#6CD800] border border-[#6CD800]/20' : 'bg-yellow-500/10 text-yellow-400 border border-yellow-500/20'
                    }`}>{p.status}</span>
                  </td>
                  <td className="px-6 py-4 text-xs text-gray-500">{p.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Billing;
